<table width="100%" class="no-spacing-no-padding-table">
    <tr>
        <td width="100%">
        </td>
        <td>
            <ng-content></ng-content>
        </td>
    </tr>
</table>
